import { ToggleButton, ToggleButtonGroup } from '@cast/design-system';
import { Cloud } from '@cast/shared-types';
import { CloudAssetIntegrationsScope } from '@cast/types-inventory';

import { providerToScopeOptions } from '../_constants';

type ScopeToggleProps = {
  provider: Cloud;
  scope?: CloudAssetIntegrationsScope;
  onScopeChange: (scope?: CloudAssetIntegrationsScope) => void;
};

export const ScopeToggle = ({
  provider,
  scope,
  onScopeChange,
}: ScopeToggleProps) => {
  const options = providerToScopeOptions[provider];

  if (options.length < 2) {
    return null;
  }

  return (
    <ToggleButtonGroup
      value={scope}
      size="sm"
      exclusive
      onChange={(_event, newValue) => {
        if (newValue !== null) {
          onScopeChange(newValue as CloudAssetIntegrationsScope);
        }
      }}
    >
      {options.map((option) => (
        <ToggleButton
          key={option.value}
          value={option.value}
          text={option.label}
        />
      ))}
    </ToggleButtonGroup>
  );
};
